const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://bizlinks.in/api';
const ASSETS_BASE_URL = process.env.REACT_APP_ASSETS_URL || 'https://bizlinks.in';

export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: `${API_BASE_URL}/auth/login`,
        REGISTER_ORG: `${API_BASE_URL}/auth/register-organization`,
        REGISTER_USER: `${API_BASE_URL}/auth/register-user`,
    },
    ORGANIZATIONS: `${API_BASE_URL}/organizations`,
    USERS: `${API_BASE_URL}/users`,
    POSTS: `${API_BASE_URL}/posts`,
    MEMBERS: `${API_BASE_URL}/users/approved`,
    NOTIFICATIONS: `${API_BASE_URL}/notifications`,
    REFERRALS: `${API_BASE_URL}/references`,
    EVENTS: `${API_BASE_URL}/events`,
    TRAININGS: `${API_BASE_URL}/trainings`,
    MEETINGS: `${API_BASE_URL}/meetings`,
    FILES: `${API_BASE_URL}/files`,
    CHAPTERS: `${API_BASE_URL}/chapters`,
    PUSH: `${API_BASE_URL}/push`,
    MASTER: {
        CATEGORIES: `${API_BASE_URL}/master/categories`,
        PLANS: `${API_BASE_URL}/master/plans`,
    }
};

export const ASSETS_URL = ASSETS_BASE_URL;

export const getImageUrl = (path) => {
    if (!path) return '';
    
    let processedPath = path;
    
    // Fix: If backend returned a localhost URL but client is accessing remotely (e.g. server IP)
    if (typeof window !== 'undefined' && (path.startsWith('https://bizlinks.in') || path.startsWith('http://127.0.0.1:3003'))) {
        const origin = window.location.origin;
        const hostname = window.location.hostname;
        // If we are not accessing via localhost ourselves, rewrite the localhost backend URL to the current origin
        if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
            processedPath = path.replace(/http:\/\/(localhost|127\.0\.0\.1):3003/, origin);
        }
    }
    
    if (processedPath.startsWith('http://') || processedPath.startsWith('https://') || processedPath.startsWith('data:')) {
        return processedPath;
    }
    const cleanPath = processedPath.startsWith('/') ? processedPath.substring(1) : processedPath;
    return `${ASSETS_URL.endsWith('/') ? ASSETS_URL : ASSETS_URL + '/'}${cleanPath}`;
};

export default API_ENDPOINTS;
